export default __webpack_public_path__ + "static/BRAINCUBER-0aa3ea067a5f3979d078f8b2924f80bd.png";